import * as Events from '@core/events';

export const handler = ({ field }: Pick<Events.TEventInformation<unknown>, 'field'>) => {
  field.data = {
    ...field.data,
    focused: true,
  };
};
